import { TWeight } from '@honeybook/hbui/dist/components/HBText/HBText.types';
import { TCustomFont } from '@honeybook/hbui/dist/styles/fonts';

export enum ContentWidth {
    SMALL = 's',
    MEDIUM = 'm',
    LARGE = 'l',
    FULL = 'full'
}

export enum PaddingSize {
    SMALL = 's',
    MEDIUM = 'm',
    LARGE = 'l',
    NONE = 'none',
    CUSTOM = 'custom'
}

export enum Alignment {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
    STRETCH = 'stretch'
}

export enum AlignmentType {
    Aligned = 'aligned',
    EdgeToEdge = 'edge_to_edge'
}

export enum LineStyleTypes {
    Solid = 'solid',
    HandDrawn = 'hand',
    Dashed = 'dashed'
}

export enum IconSize {
    SMALL = 's',
    MEDIUM = 'm',
    LARGE = 'l'
}

export enum IconColor {
    ORIGINAL = 'original',
    THEME = 'theme',
    WHITE = 'white'
}

export interface IStyles {}

export enum InvoiceAppearanceTypes {
    Plain = 'plain',
    ThemeColor = 'theme_color'
}

export interface IContainerBlockStyles extends IStyles {
    padding_y?: PaddingSize;
    custom_padding_y?: number;
    grid_gap?: number;
    content_width?: ContentWidth;
    background_color?: string;
    background_color_opacity?: number;
    opacity?: number;
}

export interface IScheduleSessionBlockStyles extends IStyles {
    background_color?: string;
    background_color_opacity?: number;
    corner_radius?: number;
    shadow?: number;
}

export interface IImageBlockStyles extends IStyles {
    alignment: Alignment;
    border_radius: number;
    opacity: number;
}

export interface ISocialBlockStyles extends IStyles {
    icon_alignment: Alignment;
    icon_size: IconSize;
    icon_color: IconColor;
}

export interface IVideoBlockStyles extends IStyles {
    alignment: Alignment;
    video_link: string;
    video_controls: boolean;
    loop_forever: boolean;
    auto_play: boolean;
    is_transparent_background?: boolean;
}

export interface ISpacerBlockStyles extends IStyles {
    height: number;
    line_thickness: number;
    show_line: boolean;
    line_style: LineStyleTypes;
    line_alignment: Alignment;
    line_color?: string;
    line_width: number;
    line_radius: number;
    background_color: string;
    is_hidden: boolean;
}

export interface IContractBlockStyles extends IStyles {
    padding_y: PaddingSize;
    content_width: ContentWidth;
    background_color?: string;
    background_color_opacity?: number;
}

export interface IServiceSelectionBlockStyles extends IStyles {
    background_color?: string;
    background_color_opacity?: number;
    content_width: ContentWidth;
    corner_radius?: number;
    custom_padding_y?: number;
    display_description?: boolean;
    display_image?: boolean;
    display_quantity?: boolean;
    display_service_price?: boolean;
    display_total_price?: boolean;
    display_unit?: boolean;
    display_unit_price?: boolean;
    grid_gap?: number;
    item_background_color?: string;
    padding_y: PaddingSize;
    select_button_text?: string;
    service_item_styles?: IServiceItemBlockStyles;
    service_pricing?: IBlockFakeCkEditorStyles;
    service_pricing_link?: IBlockFakeCkEditorStyles;
    service_select_button?: IBlockFakeCkEditorStyles;
    service_sub_item_pricing?: IBlockFakeCkEditorStyles;
    shadow?: number;
    sub_item_title?: IBlockFakeCkEditorStyles;
    sub_item_total_price?: IBlockFakeCkEditorStyles;
    title?: IBlockFakeCkEditorStyles;
    total_price?: IBlockFakeCkEditorStyles;
}

export interface IServicesItemsContainerBlockStyles extends IStyles {
    content_width: ContentWidth;
    grid_gap?: number;
}
export interface IInvoiceBlockStyles extends IStyles {
    padding_y: PaddingSize;
    content_width: ContentWidth;
    background_color?: string;
    background_color_opacity?: number;
}

export interface IInvoiceHeaderBlockStyles extends IStyles {
    show_company_logo: boolean;
    show_company_details: boolean;
    show_project_details: boolean;
    show_title: boolean;
    show_bill_to: boolean;
    show_po: boolean;
}

export interface IInvoiceColumnHeaderBlockStyles extends IContainerBlockStyles {
    invoice_appearance: InvoiceAppearanceTypes;
    show_image: boolean;
    show_tax_1: boolean;
    show_tax_2: boolean;
    show_tax_3: boolean;
    show_quantity_and_price: boolean;
    show_unit: boolean;
}

export interface IServiceItemBlockStyles extends IContainerBlockStyles {
    show_image: boolean;
    border_radius?: number;
    qb_item_id?: string;
}

export interface IInvoiceServiceItemBlockStyles
    extends IServiceItemBlockStyles {}

export interface IServiceSelectionItemBlockStyles
    extends IServiceItemBlockStyles {
    show_description?: boolean;
    show_quantity?: boolean;
    show_unit_price?: boolean;
    show_sub_item_price?: boolean;
    shadow?: number;
    display_sub_items_styles?: boolean;
}

export interface ICompanyInfoStyles extends IStyles {
    alignment: 'left' | 'center' | 'right';
    title_font_size: number;
    details_font_size?: number;
}

export interface IBlockFakeCkEditorStyles {
    font_family?: TCustomFont;
    font_size?: string;
    font_color?: string;
    font_weight?: TWeight;
    underline?: boolean;
    italic?: boolean;
    alignment?: Alignment;
    button_alignment?: Alignment;
    button_alignment_type?: AlignmentType;
}
export type TBlockFakeCkEditorStylesKeys = keyof IBlockFakeCkEditorStyles;
